import {createFileRoute} from '@tanstack/react-router'
import RyderCupLiveView from '../../rydercup/RyderCupLiveView'
import services from '../../services'
import {config} from '../../config/config'
import {humanizeSlug} from '../../utilities'

export const Route = createFileRoute('/live/ryder-cup/$ryder_cup_uid')({
    component: RouteComponent,
    // Fetch the ryder cup server-side so the title/description render in the SSR HTML (SEO).
    loader: async ({params}) => {
        try {
            const data = await services.ryderCup.dashboard(params.ryder_cup_uid)
            return {event: (data as any)?.ryder_cup || null}
        } catch {
            return {event: null}
        }
    },
    head: ({loaderData, params}) => {
        const e: any = (loaderData as any)?.event
        const name = e?.title || humanizeSlug(params.ryder_cup_uid)
        const sport = e?.sport_type ? String(e.sport_type).replace(/_/g, ' ') : 'sports'
        const slug = e?.slug || params.ryder_cup_uid
        const a = e?.captain_a_name || 'Team A'
        const b = e?.captain_b_name || 'Team B'
        return {
            meta: [
                {title: `${name} | Live Ryder Cup | ScorePal`},
                {name: 'description', content: `Follow ${name} live on ScorePal. Real-time ${sport} Ryder Cup scores, rounds, matchups, and team standings between ${a} and ${b}.`},
            ],
            links: [{rel: 'canonical', href: `${config.publicUrl}/live/ryder-cup/${slug}/`}],
        }
    },
})

function RouteComponent() {
    return <RyderCupLiveView />
}
